var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "15 15 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0.8,
    d: "M24.995 15a.714.714 0 0 0-.704.714v12.565l-4.493-4.493a.714.714 0 0 0-1.01 1.01l5.713 5.712.008.007.001.001a.703.703 0 0 0 .022.02v.002l.03.025.001.001.019.014.002.001.034.024.003.002.025.016.004.002.029.016.004.002a.207.207 0 0 0 .025.012l.005.001.028.014.005.001c.007.004.02.007.032.012l.005.001a.485.485 0 0 0 .025.009l.005.001.032.008h.004a.285.285 0 0 0 .03.007h.004a.445.445 0 0 0 .03.005h.004a.393.393 0 0 0 .034.004h.002l.037.001h.035a.696.696 0 0 0 .063-.004h-.003l.01-.001h-.005a.659.659 0 0 0 .048-.007h-.004a1.25 1.25 0 0 0 .039-.008l-.005.001a.566.566 0 0 0 .032-.008l-.005.001.047-.014-.005.001c.014-.004.022-.008.03-.011l-.003.002a.415.415 0 0 0 .041-.018l-.004.002.058-.03-.004.003.005-.003-.003.001a.591.591 0 0 0 .043-.026l-.002.001.03-.02-.002.001a.82.82 0 0 0 .047-.037l.004-.004.033-.03 5.711-5.71a.714.714 0 0 0-.498-1.226h-.022.002a.713.713 0 0 0-.491.215l-4.493 4.493V15.726v-.01a.714.714 0 0 0-.714-.713h-.01V15zm-9.271 18.572h-.01a.714.714 0 1 0 0 1.428H34.296a.714.714 0 1 0 0-1.428H15.724z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.527db3e60d78f4f431b9c371611a67fd.svg";
export { ForwardRef as ReactComponent };